// extracted by mini-css-extract-plugin
export default {"SettingsButton":"SettingsButton_SettingsButton__2ZJ-o","SettingsButton__Caption":"SettingsButton_SettingsButton__Caption__YSISq"};